// extracted by mini-css-extract-plugin
module.exports = {"products":"tu-z","oosMessaging":"uu-z"};